import { OrganizationUnitCooperationSelection as OrganizationUnitCooperationSelectionType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import Core from './Core'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import checkForAvailability from './helper/checkForAvailability'
import Number from '../../../../../UI/Input/Number'

const OrganizationUnitCooperationSelection: React.FC<Props<OrganizationUnitCooperationSelectionType>> = ({ survey, element, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const set = (key: keyof OrganizationUnitCooperationSelectionType) => (value: string) => update({ ...element, [key]: value })

  return (
    <div>
      {checkForAvailability(survey, element.type) ? (
        <Core element={element} update={update} />
      ) : (
        <div>{t.survey.configuration.organizationUnitCooperationSelection.empty}</div>
      )}
      <Number
        label={t.survey.configuration.organizationUnitCooperationSelection.maxAnswerCount}
        value={element.maxMultipleChoice}
        onChange={set('maxMultipleChoice')}
      />
    </div>
  )
}

export default OrganizationUnitCooperationSelection
